import React, { FC } from 'react';
import { MultiAppointmentStep } from '../../types';

interface IStepIndicatorProps {
  currentStep: MultiAppointmentStep;
  onStepClick: (step: MultiAppointmentStep) => void;
  canProceed: (step: MultiAppointmentStep) => boolean;
  omitSteps?: Set<MultiAppointmentStep>;
}

const ALL_STEPS = [
  { step: MultiAppointmentStep.PatientTrial, label: 'Patient & Trial' },
  { step: MultiAppointmentStep.VisitSelection, label: 'Visits to Schedule' },
  { step: MultiAppointmentStep.SlotPicker, label: 'Find Availability' },
  { step: MultiAppointmentStep.NotificationSettings, label: 'Notification Settings' },
  { step: MultiAppointmentStep.ReviewConfirm, label: 'Review & Confirm' },
];

export const StepIndicator: FC<IStepIndicatorProps> = ({ currentStep, onStepClick, canProceed, omitSteps }) => {
  const steps = ALL_STEPS.filter(({ step }) => !omitSteps?.has(step));

  return (
    <div className="multi-appointment-steps">
      {steps.map(({ step, label }, index) => {
        const isActive = step === currentStep;

        const isCompleted = step < currentStep;

        let className = 'multi-appointment-step';
        if (isActive) className += ' multi-appointment-step--active';
        if (isCompleted) className += ' multi-appointment-step--completed';

        return (
          <React.Fragment key={step}>
            {index > 0 && (
              <div
                className={`multi-appointment-step-connector${isCompleted ? ' multi-appointment-step-connector--completed' : ''}`}
              />
            )}
            <div
              className={className}
              onClick={() => {
                if (isCompleted || step <= currentStep) {
                  onStepClick(step);
                }
              }}
            >
              <div className="multi-appointment-step-number">
                {isCompleted ? '✓' : index + 1}
              </div>
              <div className="multi-appointment-step-label">
                {label}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
